<template>
  <AppScrollbar class="error-unknown" style="height: 100%">
    <div class="error-info clearfix">
      <img ref="errorImg" class="error-img select-none" src="../../../assets/error/unknown.gif" alt=""/>
      <div class="button-group">
        <el-button type="warning" size="mini" plain v-if="$route.query.redirect" @click="refreshPage">点击重试</el-button>
      </div>
      <div class="tip-msg">
        <span>请求出现错误<span v-if="$route.query.errCode">（错误码：{{$route.query.errCode}}）</span>，您可以选择<a :href="getHomePath()">重新登录</a>尝试解决此问题</span>
      </div>
    </div>
  </AppScrollbar>
</template>

<script>
import Support from '../../../mixins/support'
import AppScrollbar from '../../elements/AppScrollbar'
export default {
  mixins: [Support],
  name: 'Error403',
  components: {AppScrollbar},
  props: {
    refresh: Boolean
  },
  methods: {
    // 刷新页面
    refreshPage () {
      this.$router.replace({ path: this.$route.query.redirect })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!from.matched || from.matched.length === 0) {
        // 首次打开
        vm.refreshPage()
      }
    })
  },
  mounted () {
    let errorImg = this.$refs['errorImg']
    if (errorImg) {
      errorImg.src = errorImg.src + '?' + new Date().getTime()
    }
  },
  watch: {
    refresh: function (val) {
      if (val) {
        this.refreshPage()
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/color" as *;

  .error-unknown {
    background-color: #fff!important;
    .error-info {
      text-align: center;
      & > .error-img {
        margin: 5% auto 0;
        max-width: 100%;
        height: 360px;
        background: url("../../../assets/error/unknown.gif") center no-repeat;
        background-size: contain;
        transform: translateX(42px);
      }
      & > .button-group {
        margin: 20px auto;
        text-align: center;
        .el-button {
          padding: 5px 12px;
          border-radius: 0;
        }
      }
      & > .tip-msg {
        margin: 0 auto 50px;
        text-align: center;
        font-size: 12px;
        color: #909399;
        a {
          margin: 0 2px;
          color: $set-primary-color;
          text-decoration: none;
        }
      }
    }
  }
</style>
